import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import SEO from '../components/shared/SEO';

export default function SubscriptionConfirmedPage() {
  const [params] = useSearchParams();
  const success = params.get('status') !== 'error';

  return (
    <Layout>
      <SEO
        title="Subscription Confirmed — Apex DeFi Labs Inc."
        description="Your email subscription has been confirmed."
        url="https://apexdefilabs.com/subscription-confirmed"
      />
      <section style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F9F6EF' }}>
        <div style={{ textAlign: 'center', padding: '0 24px', maxWidth: '520px', margin: '0 auto' }}>
          {success ? (
            <>
              <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'rgba(76,175,122,0.1)', border: '1px solid rgba(76,175,122,0.35)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 2rem', fontSize: '2rem' }}>
                ✓
              </div>
              <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '2rem', fontWeight: 800, color: '#0A1628', marginBottom: '1rem' }}>
                You're Confirmed
              </h1>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1rem', lineHeight: 1.75, color: '#6B7E94', marginBottom: '2.5rem' }}>
                Your email has been confirmed. You'll now receive Apex DeFi Labs Inc. insights, market intelligence, and updates directly to your inbox.
              </p>
            </>
          ) : (
            <>
              <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: 'rgba(224,85,85,0.08)', border: '1px solid rgba(224,85,85,0.3)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 2rem', fontSize: '2rem', color: '#e05555' }}>
                ✕
              </div>
              <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: '2rem', fontWeight: 800, color: '#0A1628', marginBottom: '1rem' }}>
                Link Invalid or Expired
              </h1>
              <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1rem', lineHeight: 1.75, color: '#6B7E94', marginBottom: '2.5rem' }}>
                This confirmation link is invalid or has already been used. If you haven't confirmed yet, please subscribe again to receive a new link.
              </p>
            </>
          )}

          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link
              to="/"
              style={{ display: 'inline-block', padding: '0.875rem 2rem', background: '#0A1628', color: '#F9F6EF', fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: '0.85rem', letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none' }}
            >
              Back to Home
            </Link>
            <Link
              to="/insights"
              style={{ display: 'inline-block', padding: '0.875rem 2rem', border: '1px solid rgba(184,134,11,0.35)', color: '#B8860B', fontFamily: "'DM Sans', sans-serif", fontSize: '0.85rem', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', textDecoration: 'none' }}
            >
              Browse Insights
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
}
